import { useEffect } from 'react';

const ScreenshotProtection = ({ children, enabled = true }) => {
  useEffect(() => {
    if (!enabled) return;

    // CSS für Screenshot-Schutz hinzufügen
    const style = document.createElement('style');
    style.textContent = `
      .screenshot-protected {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: transparent;
      }
      
      .screenshot-protected::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: -1;
        pointer-events: none;
      }
      
      @media print {
        .screenshot-protected {
          display: none !important;
        }
        .screenshot-protected::after {
          content: 'Drucken ist nicht erlaubt';
          display: block;
          text-align: center;
          font-size: 24px;
          padding: 50px;
        }
      }
    `;
    document.head.appendChild(style);

    // Keyboard-Events abfangen
    const handleKeyDown = (e) => {
      // PrintScreen (Windows)
      if (e.key === 'PrintScreen') {
        e.preventDefault();
        console.warn('Screenshot-Versuch erkannt');
      }
      
      // Windows+Shift+S (Snipping Tool)
      if ((e.metaKey || e.key === 'Meta' || e.code === 'MetaLeft' || e.code === 'MetaRight') && 
          e.shiftKey && e.key === 'S') {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.warn('Windows Snipping Tool blockiert');
        return false;
      }
      
      // Alt+PrintScreen
      if (e.altKey && e.key === 'PrintScreen') {
        e.preventDefault();
        console.warn('Alt+PrintScreen blockiert');
      }
      
      // Ctrl+P (Drucken)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        alert('Drucken ist nicht erlaubt');
      }
      
      // Cmd+Shift+3/4/5 (Mac Screenshots)
      if (e.metaKey && e.shiftKey && (e.key === '3' || e.key === '4' || e.key === '5')) {
        e.preventDefault();
        console.warn('Screenshot-Versuch erkannt (Mac)');
      }
      
      // F12 (Developer Tools)
      if (e.key === 'F12') {
        e.preventDefault();
        console.warn('Developer Tools blockiert');
      }
      
      // Ctrl+Shift+I (Developer Tools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        console.warn('Developer Tools blockiert');
      }
      
      // Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        console.warn('View Source blockiert');
      }
    };

    // Context Menu erlauben (Rechtsklick aktiviert)
    // const handleContextMenu = (e) => {
    //   e.preventDefault();
    // };

    // DevTools Detection
    let devtools = {
      open: false,
      orientation: null
    };
    
    const threshold = 160;
    setInterval(() => {
      if (window.outerHeight - window.innerHeight > threshold || 
          window.outerWidth - window.innerWidth > threshold) {
        if (!devtools.open) {
          devtools.open = true;
          console.warn('Developer Tools erkannt');
        }
      } else {
        devtools.open = false;
      }
    }, 1000);

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyDown); // Also listen on keyup
    // document.addEventListener('contextmenu', handleContextMenu); // Rechtsklick erlaubt
    
    // Additional Windows key detection
    window.addEventListener('keydown', handleKeyDown, true); // Capture phase
    window.addEventListener('keyup', handleKeyDown, true);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyDown);
      // document.removeEventListener('contextmenu', handleContextMenu); // Rechtsklick erlaubt
      window.removeEventListener('keydown', handleKeyDown, true);
      window.removeEventListener('keyup', handleKeyDown, true);
    };
  }, [enabled]);

  if (!enabled) {
    return children;
  }

  return (
    <div className="screenshot-protected">
      {children}
    </div>
  );
};

export default ScreenshotProtection;
